// extracted by mini-css-extract-plugin
export default {"container":"Empty_container__2Mg4p","icon":"Empty_icon__0ZXtH","text":"Empty_text__TBYlI"};